import React from "react";
import { Helpers } from "../Helpers";
import { ReviewRating } from "../Shared";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";

export default function TourListItem({
    tour,
    productUrl,
    image,
    placeholderImage,
    isInCart = false,
    price,
    pricingType,
    tourListingCtaText,
    specific_tours,
    scrollPosition,
    onClick = (f) => f,
    lazy = true,
    vertical = false,
    showInCartIcon = true
}) {

    return (
        <div className="position-relative tour-list-item">
            <a href={productUrl} onClick={(e) => onClick(tour, e)}>
                <div className="card rounded-0 z-depth-0">
                    <div className="container">
                        <div className="row">
                            <div className={`overflow-hidden position-relative col-sm-12 ${!vertical && 'col-md-6'} p-0`}>
                                <div
                                    className="image-container"
                                    style={{
                                        height: "100%",
                                        minHeight: "267px",
                                        backgroundColor: "lightgray",
                                    }}
                                >
                                    {lazy && 
                                        <LazyLoadImage
                                            alt="tour image"
                                            height="100%"
                                            width="100%"
                                            placeholderSrc={placeholderImage}
                                            scrollPosition={scrollPosition}
                                            src={image}
                                            effect="opacity"
                                            style={{ objectFit: "cover" }}
                                        />
                                        ||
                                        <img 
                                            height="100%"
                                            width="100%"
                                            style={{ objectFit: "cover" }}
                                            src={image}
                                        />
                                    }
                                </div>

                                {_.findIndex(tour.tags.data, (_tag) => {
                                    return _tag.slug == "private-tours";
                                }) > -1 && (
                                    <div
                                        className="position-absolute"
                                        style={{ top: "10px", left: "10px" }}
                                        tabIndex="0"
                                    >
                                        <div className="btn btn-primary">
                                            <i className="fa fa-user-friends fa-fw mr-2 text-white"></i>
                                            Private
                                        </div>
                                    </div>
                                )}

                                {isInCart && showInCartIcon && (
                                    <div
                                        className="position-absolute card z-depth-0 border-black"
                                        style={{ top: "10px", right: "10px" }}
                                        tabIndex="0"
                                    >
                                        <div className="card-body text-center p-2 black primary-text">
                                            <i className="fa fa-shopping-cart mr-2"></i>
                                            <i className="fa fa-check"></i>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className={`col-sm-12 ${!vertical && 'col-md-6'} border-top-0 p-4 pb-5 position-relative`}>
                                <h4 className="three-b-text font-weight-bold body-font mb-3">
                                    {tour.name}
                                </h4>

                                {!_.isNull(tour.average_rating) && (
                                    <ReviewRating
                                        star_rating={tour.average_rating}
                                        count={tour.reviews_count}
                                    />
                                )}

                                {!_.isEmpty(tour.date_settings) &&
                                    !_.isEmpty(tour.date_settings.duration) && (
                                        <div className="mb-3 text-muted font-small">
                                            <i className="far fa-clock mr-1"></i>
                                            <span>
                                                {tour.date_settings.duration}
                                            </span>
                                        </div>
                                    )}

                                <div className="mb-4">
                                    <div className="media">
                                        <div className="mr-2 align-self-center">
                                            <div
                                                className="body-text-color text-uppercase"
                                                style={{
                                                    lineHeight: 0.75,
                                                    fontSize: 12,
                                                }}
                                            >
                                                Starting From
                                            </div>
                                            <div className="d-flex d-inline align-items-end">
                                                <h3 className="mr-1 body-font font-weight-bold primary-text">
                                                    {price}
                                                </h3>
                                                <span
                                                    className="body-text-color align-self-center"
                                                    style={{
                                                        lineHeight: 0.75,
                                                        fontSize: 12,
                                                    }}
                                                >
                                                    {pricingType}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {!_.isEmpty(tour.inclusions) && (
                                    <div>
                                        <ul
                                            key="includes"
                                            className="list-inline mb-0 font-small mb-3"
                                        >
                                            <li className="list-inline-item mr-3">
                                                <span className="font-weight-bold body-text-color">
                                                    Includes:
                                                </span>
                                            </li>

                                            {tour.inclusions.map(
                                                (inclusion, key) => {
                                                    return (
                                                        <li
                                                            key={key}
                                                            className="list-inline-item mr-3 body-text-color"
                                                        >
                                                            <i
                                                                className={
                                                                    inclusion.icon +
                                                                    " fa mr-1"
                                                                }
                                                            ></i>
                                                            {inclusion.name}
                                                        </li>
                                                    );
                                                }
                                            )}
                                        </ul>
                                    </div>
                                )}
                                {!_.isEmpty(tourListingCtaText) && (
                                    <div
                                        className="text-right mt-3 position-absolute"
                                        style={{
                                            right: "25px",
                                            bottom: "25px",
                                        }}
                                    >                                        
                                        <button className="btn btn-link primary-text p-0">
                                            {specific_tours && "Learn More" || tourListingCtaText}
                                            <i className="fa fa-angle-right ml-2"></i>
                                        </button>                                        
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./resources/js/components/TourListItem/index.js